export default "__VITE_ASSET__b3fe3809__"